import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import { buildGrowthEfficiencyChart } from "./funnelChartUtils";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  extractTableBlock,
  splitByHeading,
  extractAnalysisPeriod,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelGrowthEfficiency = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "Growth Efficiency";
  const lines = stripTitleLines(cleanLines(markdown));
  const analysisPeriod = extractAnalysisPeriod(lines);
  const filteredLines = lines.filter((line) => !/^analysis period/i.test(line));
  const { table, before, after } = extractTableBlock(filteredLines);
  const renamedTable =
    table && Array.isArray(table.headers)
      ? {
          ...table,
          headers: table.headers.map((cell) => {
            const text = String(cell || "");
            if (text.trim() === "CM2 / Order") {
              return "Contribution After Marketing / Order";
            }
            if (text.trim() === "LTV / Customer") {
              return "Lifetime Value / Customer";
            }
            return text;
          }),
        }
      : table;
  const chart = buildGrowthEfficiencyChart(renamedTable);
  const { tail } = splitByHeading(after, "What Does This Mean?");
  const bullets = toBullets(tail);
  let paragraphs = toParagraphs(tail);
  const verdict = extractVerdict(paragraphs);
  if (verdict) paragraphs = paragraphs.slice(0, -1);

  return (
    <FunnelInsightCard
      title={title}
      kicker="Channel Mix"
      sections={[
        {
          title: "Channel Efficiency",
          chart,
          chartTitle: "Efficiency by Channel",
          chartSubtitle:
            "Grouped bars help compare acquisition quality across channels without frying the reader’s brain.",
          table: renamedTable,
          meta: analysisPeriod ? `Analysis Period: ${analysisPeriod}` : null,
          paragraphs: before.length ? toParagraphs(before) : [],
        },
        {
          title: "What Does This Mean?",
          bullets,
          paragraphs,
          verdict,
        },
      ]}
    />
  );
};

export default FunnelGrowthEfficiency;
